import { useEffect } from 'react';
import Select from 'react-select';
import { Form } from 'react-simple-form-control';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import enderecoService from '../../services/EnderecoService';
import solicitacaoService from '../../services/SolicitacaoService';
import empresaService from '../../services/EmpresaService';
import { aplicarMascaraCNPJ, normalizarCNPJ, isNullOrEmptyOrWhiteSpaceOrUndefined } from '../../helpers/Helper';

const DadosEmpresaConveniada = ({ form, onChangeForm, setLoading }) => {
    const navigate = useNavigate();

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);
        let _form = { ...form };

        const listSegmento = await empresaService.OnGetSegmentos();

        _form.listSegmento.value = listSegmento;

        onChangeForm(_form);
        setLoading(false);
    }

    async function handleCnpjChange(event) {
        setLoading(true);

        const cnpjValue = aplicarMascaraCNPJ(event.target.value);
        handleInputChange(event);

        let _form = { ...form };
        _form.cnpj.value = cnpjValue;

        if (cnpjValue === "" || cnpjValue === "00.000.000/0000-00") {
            _form.razaoSocial.value = "";
            _form.cnpj.value = "";
            _form.nomeFantasia.value = "";
            _form.inscricaoEstadual.value = "";
            _form.site.value = "";
            _form.habilitaDadosEmpresa.value = false;
            setLoading(false);
            onChangeForm(_form);
            return;
        }

        if (cnpjValue !== undefined && cnpjValue !== null && cnpjValue !== "" &&
            cnpjValue !== 0 && cnpjValue !== "00.000.000/0000-00" && normalizarCNPJ(cnpjValue).length === 14) {

            try {
                const cleanedCnpj = normalizarCNPJ(cnpjValue);
                const res = await solicitacaoService.getDadosPorCNPJ(cleanedCnpj);

                if (res.success === true && res.data !== null && res.data !== undefined &&
                    res.data.idSolicitacao !== null && res.data.idSolicitacao !== undefined && res.data.idSolicitacao !== 0) {
                    toast.warn("Empresa já cadastrada e com solicitação realizada. Entre com o login e senha ou faça a solicitação dos seus dados de acesso junto ao setor comercial da Uninter S/A.");
                    navigate("/login");
                }
                else if (res.success === true && res.data !== null && res.data !== undefined &&
                    res.data.empresa !== undefined && res.data.empresa !== null) {

                    _form.idEmpresa.value = res.data.empresa.id || 0;
                    _form.razaoSocial.value = res.data.empresa.razaoSocial || "";
                    _form.nomeFantasia.value = res.data.empresa.nomeFantasia || "";
                    _form.inscricaoEstadual.value = res.data.empresa.inscricaoEstadual || "";
                    _form.site.value = res.data.empresa.site || "";
                    _form.idZipCode.value = res.data.empresa.zipCodeId || "";
                    _form.idCidade.value = res.data.empresa.cidadeId || 0;
                    _form.cidade.value = res.data.empresa.cidade || "";
                    _form.uf.value = res.data.empresa.uf || "";
                    _form.bairro.value = res.data.empresa.bairro || "";
                    _form.complemento.value = res.data.empresa.complemento || "";
                    _form.numero.value = res.data.empresa.numero || "";
                    _form.rua.value = res.data.empresa.logradouro || "";
                    _form.cep.value = res.data.empresa.cep || "";
                    _form.numeroColaboradores.value = res.data.empresa.qtdeFuncionarios || 0;
                    _form.ru.value = res.data.empresa.ru || 0;
                    _form.habilitaDadosEmpresa.value = res.data.empresa.razaoSocial !== "" && res.data.empresa.razaoSocial !== null;

                    onChangeForm(_form);
                } else {
                    _form.razaoSocial.value = "";
                    _form.nomeFantasia.value = "";
                    _form.inscricaoEstadual.value = "";
                    _form.site.value = "";
                    _form.idZipCode.value = 0;
                    _form.habilitaDadosEmpresa.value = false;

                    onChangeForm(_form);
                }
            } catch (e) {
                toast.error("Erro ao buscar dados da empresa pelo CNPJ.");
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }

    async function handleCepChange(event) {
        const cepValue = event.target.value;
        handleInputChange(event);

        let _form = { ...form };

        if (cepValue === "00000-000") {
            _form.cep.value = "";
            _form.cidade.value = "";
            _form.idCidade.value = "";
            _form.uf.value = "";
            _form.rua.value = "";
            _form.bairro.value = "";
            _form.habilitacep = false;
            onChangeForm(_form);
            return;
        }

        if (cepValue && cepValue.length === 9 && cepValue !== "00000-000") {
            setLoading(true);

            try {
                const res = await enderecoService.getCep(cepValue);

                _form.cidade.value = res.cidade;
                _form.uf.value = res.uf;
                _form.rua.value = res.logradouro;
                _form.bairro.value = res.bairro;
                _form.idCidade.value = res.idCidade;
                _form.habilitacep = res.bairro === "" || res.bairro === null;

                onChangeForm(_form);

                if (typeof res.id === "undefined") {
                    toast.warn("CEP não encontrado");
                }
            } catch (e) {
                toast.error("Erro ao buscar CEP");
            } finally {
                setLoading(false);
            }
        }
    }

    async function handleResponsavelChange(event) {
        let _form = { ...form };
        let nomeResponsavel = event.target.value.toUpperCase();
        let codigoResponsavel = event.currentTarget.id;

        const novaLista = _form.listResponsaveis.value.filter(e => e.codigo !== codigoResponsavel);

        if (!isNullOrEmptyOrWhiteSpaceOrUndefined(nomeResponsavel)) {
            novaLista.push({
                descricao: nomeResponsavel,
                codigo: codigoResponsavel
            });
        }

        _form.listResponsaveis.value = novaLista;
        onChangeForm(_form);
    }

    async function handleSegmentoChange(event) {
        let _form = { ...form };
        _form.idsegmento.value = event.value;
        onChangeForm(_form);
    }

    async function handleInputChange(e) {
        const { name, value, type, checked } = e.target;
        let _form = { ...form };
        _form[name].value = type === "checkbox" ? checked : value;
        onChangeForm(_form);
    }

    return (
        <Form formControl={form}>
            <div className="card-body">
                <ul className="uninterconvenioempresas uninter-passo-interno">
                    <li>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>CNPJ</label>
                            <input type="text" id="cnpj" name="cnpj" maxLength="18" onBlur={handleCnpjChange} />
                            <span className="error" id="cnpjError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                            <label>Inscrição Estadual/(Isento)</label>
                            <input type="text" id="inscricaoEstadual" name="inscricaoEstadual" disabled={form.habilitaDadosEmpresa.value}
                                value={form.inscricaoEstadual.value} onChange={handleInputChange} />
                            <span className="error" id="inscricaoEstadualError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                            <label>Razão Social</label>
                            <input type="text" id="razaoSocial" name="razaoSocial" minLength="5" maxLength="80" disabled={form.habilitaDadosEmpresa.value} onBlur={handleResponsavelChange}
                                value={form.razaoSocial.value} onChange={handleInputChange} />
                            <span className="error" id="razaoSocialError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                            <label>Nome Fantasia</label>
                            <input type="text" id="nomeFantasia" name="nomeFantasia" minLength="2" maxLength="80" disabled={form.habilitaDadosEmpresa.value}
                                value={form.nomeFantasia.value} onChange={handleInputChange} />
                            <span className="error" id="nomeFantasiaError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 uninter-campos">
                            <label>Email</label>
                            <input id="emailEmpresa" name="emailEmpresa" maxLength="250" type="email"
                                value={form.emailEmpresa.value} onChange={handleInputChange} />
                            <span className="error" id="emailEmpresaError"></span>
                        </div>
                        <div className="row uninter-container-row">
                            <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 uninter-campos">
                                <label>CEP</label>
                                <input type="text" id="cep" name="cep" maxLength="10" onBlur={handleCepChange} />
                                <span className="error" id="cepError"></span>
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-8 col-lg-8 uninter-campos">
                                <label>Rua/Logradouro</label>
                                <input type="text" id="rua" name="rua" value={form.rua.value} onChange={handleInputChange} />
                                <span className="error" id="ruaError"></span>
                            </div>
                            <div className="col-xs-4 col-sm-3 col-md-2 col-lg-2 uninter-campos">
                                <label>Nº/(S/N)</label>
                                <input type="text" id="numero" name="numero" value={form.numero.value} onChange={handleInputChange} />
                                <span className="error" id="numeroError"></span>
                            </div>
                        </div>
                        <div className="row uninter-container-row">
                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 uninter-campos">
                                <label>Bairro</label>
                                <input type="text" id="bairro" name="bairro" value={form.bairro.value} onChange={handleInputChange} />
                                <span className="error" id="bairroError"></span>
                            </div>

                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                                <label>Cidade</label>
                                <input type="text" id="cidade" name="cidade" disabled='true' value={form.cidade.value} onChange={handleInputChange} />
                                <span className="error" id="cidadeError"></span>
                            </div>
                            <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 uninter-campos">
                                <label>UF</label>
                                <input type="text" id="uf" name="uf" disabled='true' value={form.uf.value} onChange={handleInputChange} />
                                <span className="error" id="ufError"></span>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5 uninter-campos">
                            <label>Site <span className="indicativoSite">(se houver)</span></label>
                            <input type="text" id="site" name="site" maxLength="100" value={form.site.value} onChange={handleInputChange} />
                            <span className="error" id="siteError"></span>
                        </div>
                        <div className="col-xs-6 col-sm-3 col-md-3 col-lg-3 uninter-campos">
                            <label>Número de Colaboradores</label>
                            <input type="text" id="numeroColaboradores" name="numeroColaboradores" value={form.numeroColaboradores.value} onChange={handleInputChange} />
                            <span className="error" id="numeroColaboradoresError"></span>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 uninter-campos ">
                            <label htmlFor="segmento">Segmento</label>
                            <Select
                                onChange={handleSegmentoChange}
                                isLoading={form.listSegmento.value.length === 0}
                                options={form.listSegmento.value.map((o) => ({
                                    id: o.idSegmento,
                                    value: o.idSegmento,
                                    label: o.descricao,
                                }))}
                                placeholder="SELECIONE"
                                id="idsegmento"
                                name="segmento"
                                defaultValue={{ label: "SELECIONE", value: 0 }}
                                value={
                                    form.idsegmento.value !== 0
                                        ? form.listSegmento.value.find(e => e.idSegmento === form.idsegmento.value) && {
                                            label: form.listSegmento.value.find(e => e.idSegmento === form.idsegmento.value)?.descricao,
                                            value: form.idsegmento.value
                                        }
                                        : { label: "SELECIONE", value: 0 }
                                }
                            />
                            <span className="error" id="estadoError"></span>
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 uninter-campos">
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label">Controlar Colaboradores Conveniados</label>
                                <li className="form-check">
                                    <input type="checkbox" id="controleColaboradores" name="controleColaboradores" value="1" checked={form.controleColaboradores.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 uninter-campos">
                            <ul className="uninter-declaro-convenioempresas">
                                <label className="label">Permite Ofertas Curso?</label>
                                <li className="form-check">
                                    <input type="checkbox" id="permiteOfertarCursos" name="permiteOfertarCursos" value="1" checked={form.permiteOfertarCursos.value} onChange={handleInputChange} />
                                    <label className="label">Sim</label>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </Form>
    );
}

export default DadosEmpresaConveniada;